var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Button, Container, Grid, GridColumn, Notice, Separator } from 'telia-front-react';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import customerIdAsKey from '../auth/customerIdAsKey';
import config from '../Config';
import { createGaEvent } from '../util/GaUtil';
import { addLanguageSlugToUrl } from '../util/PathUtil';
import { injectStores } from '../util/StoresUtil';
let DebtNotice = class DebtNotice extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "debtStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    componentDidMount() {
        return this.debtStore.init();
    }
    render() {
        const { translate, currentLanguage } = this.translateStore;
        if (!this.debtStore.debtLoaded || !this.debtStore.isInDebt) {
            return null;
        }
        return (React.createElement(Container, null,
            React.createElement(Notice, { type: "error", align: "center" },
                React.createElement(Grid, { align: ['between-xs', 'middle-xs'] },
                    React.createElement(GridColumn, { width: ['xs'] }, `${translate('debt.notice')}`),
                    React.createElement(GridColumn, { width: ['xs'] },
                        React.createElement(Button, { text: translate('debt.notice.button'), iconRight: "#arrow-right", type: "expressive", url: addLanguageSlugToUrl(config.billsUrl, currentLanguage), onClick: () => createGaEvent({ eventCategory: 'Iseteenindus - Avaleht', eventAction: 'Top Alert - Võlateavitus', eventLabel: 'Vaata lähemalt' }) })))),
            React.createElement(Separator, { color: "invisible", spacing: "xsmall" })));
    }
};
DebtNotice = __decorate([
    customerIdAsKey,
    injectStores,
    observer
], DebtNotice);
export default DebtNotice;
